import { Injectable } from "@angular/core"
import { Subject } from 'rxjs'
@Injectable({
    providedIn: "root"
})
export class InstrumentIDService {

    private iid = new Subject<string>()
    public iidj$ = this.iid.asObservable()

    public listener = false

    setIID(iid: string) {
        this.iid.next(iid)
    }

}